// 打印类属性、方法定义
/* eslint-disable */
const Print = function (dom, options) {
  if (!(this instanceof Print)) return new Print(dom, options);

  this.options = this.extend({
    'noPrint': '.no-print'
  }, options);

  if ((typeof dom) === "string") {
    this.dom = document.querySelector(dom);
  } else {
    this.isDOM(dom)
    this.dom = this.isDOM(dom) ? dom : dom.$el;
  }
  this.init();
};
Print.prototype = {
  init: function () {
    var content = this.getStyle() + this.getHtml();
    this.writeIframe(content);
  },
  extend: function (obj, obj2) {
    for (var k in obj2) {
      obj[k] = obj2[k];
    }
    return obj;
  },

  getStyle: function () {
    var str = "",
      styles = document.querySelectorAll('style,link');
    for (var i = 0; i < styles.length; i++) {
      str += styles[i].outerHTML;
    }
    str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>"
    // str += "<style>html,body,div {height: auto !important;font-size: 14px}</style>"
    str += "<style>html,body,div {font-size: 14px}</style>"
    str += "<style>html,body,.print-iframe-wrapper,.print-iframe-wrapper * {-webkit-print-color-adjust: exact !important; print-color-adjust: exact !important;}</style>"
    if (this.options.fitToPage) {
      str += "<style>html,body { margin: 0 !important; padding: 0 !important; } .print-iframe-wrapper { break-inside: avoid; page-break-inside: avoid; }</style>"
    }
    return str;
  },

  getHtml: function () {
    var inputs = document.querySelectorAll('input');
    var textareas = document.querySelectorAll('textarea');
    var selects = document.querySelectorAll('select');
    var canvass = document.querySelectorAll('canvas');

    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
        if (inputs[k].checked == true) {
          inputs[k].setAttribute('checked', "checked")
        } else {
          inputs[k].removeAttribute('checked')
        }
      } else if (inputs[k].type == "text") {
        inputs[k].setAttribute('value', inputs[k].value)
      } else {
        inputs[k].setAttribute('value', inputs[k].value)
      }
    }

    for (var k2 = 0; k2 < textareas.length; k2++) {
      if (textareas[k2].type == 'textarea') {
        textareas[k2].innerHTML = textareas[k2].value
      }
    }

    for (var k3 = 0; k3 < selects.length; k3++) {
      if (selects[k3].type == 'select-one') {
        var child = selects[k3].children;
        for (var i in child) {
          if (child[i].tagName == 'OPTION') {
            if (child[i].selected == true) {
              child[i].setAttribute('selected', "selected")
            } else {
              child[i].removeAttribute('selected')
            }
          }
        }
      }
    }
    //canvass echars图表转为图片
    for (var k4 = 0; k4 < canvass.length; k4++) {
      var imageURL = canvass[k4].toDataURL("image/png");
      var img = document.createElement("img");
      img.src = imageURL;
      // canvas显示不全，调整成70%
      img.setAttribute('style', 'max-width: 70%;');
      img.className = 'isNeedRemove';
      canvass[k4].parentNode.insertBefore(img,canvass[k4].nextElementSibling);
    }

    return this.dom.outerHTML;
  },

  writeIframe: function (content) {
    var w, doc, iframe = document.createElement('iframe'),
      f = document.body.appendChild(iframe);
    iframe.id = "myIframe";
    // iframe.style = "position:absolute;width:100%;height:100%;top:-10px;left:-10px;z-index: 999";
    iframe.setAttribute('style', 'position: absolute;width:0;height:0;top:-10px;left:-10px;');

    w = f.contentWindow || f.contentDocument;
    doc = f.contentDocument || f.contentWindow.document;
    doc.open();
    let docBody = document.createElement('body');
      // const content2 = document.createRange().createContextualFragment(content)
    // const content2 = new DOMParser().parseFromString(htmlStr,'text/html').body.childNodes[0]
    // const content3 = new DOMParser().parseFromString(styleStr,'text/html').body.childNodes[0]
    const content3 = document.createRange().createContextualFragment(content)
    // const content2 = content.innerHTML
    // docBody.appendChild(content2)
    docBody.appendChild(content3)
    doc.appendChild(docBody)
    // doc.srcdoc = content2;
    const printWrapper = doc.getElementById('pdfDom') || docBody.lastElementChild;
    window.$(printWrapper).addClass('print-iframe-wrapper');
    window.$(doc.getElementsByTagName('body'))[0].style.overflow = 'hidden';
    // 解决组织架构图打印区域不正确问题，同时缩小组织树，增加可打印范围
    if (document.getElementsByClassName('org-tree')[0]) {
      const wrapper = window.$(doc.getElementsByClassName('print-iframe-wrapper'))[0];
      // let left = 0;
      // let top = 0;
      // if (document.getElementsByClassName('__bar-wrap-is-horizontal')[0]) {
      //   const horWrapWidth = document.getElementsByClassName('__bar-wrap-is-horizontal')[0].offsetWidth;
      //   const hor = document.getElementsByClassName('__bar-is-horizontal')[0];
      //   // const horWidth = hor.offsetWidth;
      //   const horTransfer = Number(hor.style.transform.split('translateX(')[1].split('%)')[0]);
      //   left = horWrapWidth * (horTransfer/100);
      // }
      // if (document.getElementsByClassName('__bar-wrap-is-vertical')[0]) {
      //   const verWrapHeight = document.getElementsByClassName('__bar-wrap-is-vertical')[0].offsetHeight;
      //   const ver = document.getElementsByClassName('__bar-is-vertical')[0];
      //   // const verHeight = hor.offsetHeight;
      //   const verTransfer = Number(ver.style.transform.split('translateY(')[1].split('%)')[0]);
      //   top = verWrapHeight * (verTransfer/100);
      // }
      // wrapper.style.position = 'relative';
      // wrapper.style.left = `-${left/2}px`;
      // wrapper.style.top = `-${top/2}px`;
      // wrapper.style.transformOrigin = 'left top';
      // wrapper.style.transform = 'scale(.1)';
      // wrapper.style.overflow = 'hidden';
      // wrapper.style.paddingBottom = '30px';

      let div = document.createElement('div')
      div.id="mm"
      div.style = 'width:297mm;height:201mm;'
      document.querySelector("body").appendChild(div)
      let mm1 = document.getElementById('mm').getBoundingClientRect()
      const {width,height}  = mm1
      const {offsetWidth:pageWidth,offsetHeight:pageHeight} = wrapper
      if(pageWidth > width || pageHeight > height){
        const wrate = width / pageWidth
        const hrate = height/pageHeight
        const rate =  Math.floor(Math.min(wrate,hrate)*10) / 1
        const left = (width - pageWidth * rate)/2
        wrapper.style = `transform:scale(${rate},${rate});transform-origin: left top;overflow: hidden;position:relative;left:${left}`
      }
      document.querySelector("body").removeChild( document.getElementById('mm'))
    }

    //审批详情表单显示编号、申请人
    const printTitle = document.getElementsByClassName('print-title-info')[0];
    if (printTitle) {
      const wrapper = window.$(doc.getElementsByClassName('print-iframe-wrapper'))[0];
      if (wrapper) {
        const title = wrapper.getElementsByClassName('print-title-info')[0];
        // ApprovePrint 走 iframe 打印时 wrapper 内无 print-title-info，需判空
        if (title) {
          title.style.display = 'flex';
        }
      }
    }
    //审批详情字段保持原有分列，避免打印缩放时 flex 项被压缩到一行
    const detailWrappers = doc.querySelectorAll('.form-item-info .detail-info-wrapper');
    for (var detailWrapperIndex = 0; detailWrapperIndex < detailWrappers.length; detailWrapperIndex++) {
      detailWrappers[detailWrapperIndex].style.display = 'flex';
      detailWrappers[detailWrapperIndex].style.width = '100%';
    }
    const detailInfos = doc.querySelectorAll('.form-item-info .detail-info');
    for (var detailInfoIndex = 0; detailInfoIndex < detailInfos.length; detailInfoIndex++) {
      detailInfos[detailInfoIndex].style.display = 'flex';
      detailInfos[detailInfoIndex].style.flexWrap = 'wrap';
      detailInfos[detailInfoIndex].style.alignItems = 'flex-start';
    }
    const detailFields = doc.querySelectorAll('.form-item-info .detail-info > div');
    for (var detailFieldIndex = 0; detailFieldIndex < detailFields.length; detailFieldIndex++) {
      if (detailFields[detailFieldIndex].style.width) {
        detailFields[detailFieldIndex].style.flexBasis = detailFields[detailFieldIndex].style.width;
      }
      detailFields[detailFieldIndex].style.flexGrow = '0';
      detailFields[detailFieldIndex].style.flexShrink = '0';
      detailFields[detailFieldIndex].style.float = 'none';
      detailFields[detailFieldIndex].style.boxSizing = 'border-box';
    }
    //表格类审批流（如采购）使用 userInfo span，单独保持两列布局
    const approvalInfoLists = doc.querySelectorAll('.approval-info-list');
    for (var approvalInfoListIndex = 0; approvalInfoListIndex < approvalInfoLists.length; approvalInfoListIndex++) {
      approvalInfoLists[approvalInfoListIndex].style.display = 'flex';
      approvalInfoLists[approvalInfoListIndex].style.flexWrap = 'wrap';
      approvalInfoLists[approvalInfoListIndex].style.width = '100%';
      approvalInfoLists[approvalInfoListIndex].style.alignItems = 'flex-start';
    }
    const userInfoFields = doc.querySelectorAll('.userInfo');
    for (var userInfoIndex = 0; userInfoIndex < userInfoFields.length; userInfoIndex++) {
      userInfoFields[userInfoIndex].style.boxSizing = 'border-box';
      userInfoFields[userInfoIndex].style.flexBasis = '50%';
      userInfoFields[userInfoIndex].style.flexGrow = '0';
      userInfoFields[userInfoIndex].style.flexShrink = '0';
      userInfoFields[userInfoIndex].style.width = '50%';
      userInfoFields[userInfoIndex].style.minWidth = '0';
      userInfoFields[userInfoIndex].style.padding = '10px 40px';
      userInfoFields[userInfoIndex].style.lineHeight = '20px';
      userInfoFields[userInfoIndex].style.overflowWrap = 'anywhere';
    }
    //审批详情表单完整显示
    const approveTable = document.getElementsByClassName('approve-table-info')[0];
    if (approveTable) {
      const tableHeight = approveTable.offsetHeight;
      const wrapper = window.$(doc.getElementsByClassName('print-iframe-wrapper'))[0];
      if (wrapper) {
        const table = wrapper.getElementsByClassName('approve-table-info')[0];
        if (table) {
          const tableSort = table.querySelectorAll('.ivu-table-sort');
          const tableContainer = table.parentElement;
          const fullWidthTableLayers = table.querySelectorAll(
            '.luttica-data-grid, .ivu-table-wrapper, .ivu-table, .ivu-table-header, .ivu-table-body, table'
          );
          if (tableContainer && tableContainer.classList.contains('approval-table')) {
            tableContainer.style.width = '100%';
          }
          table.style.width = '100%';
          table.style.boxSizing = 'border-box';
          for (var i = 0; i < fullWidthTableLayers.length; i++) {
            fullWidthTableLayers[i].style.width = '100%';
            fullWidthTableLayers[i].style.maxWidth = '100%';
            fullWidthTableLayers[i].style.boxSizing = 'border-box';
          }
          const tableTag = wrapper.getElementsByTagName('table');
          for (var z = 0; z < tableTag.length; z++) {
            tableTag[z].style.fontSize = '12px';
          }
          for (let y = 0; y < tableSort.length; y++) {
            tableSort[y].remove();
          }
          // const tableBody = table.getElementsByClassName('ivu-table-body')[0];
          // const tableRow = tableBody.querySelectorAll('.ivu-table-row');
          // if (tableBody && tableRow && tableRow.length) {
          //   const bodyHeight = tableRow.length * 57;
          //   const bodyChild = tableBody.firstElementChild;
          //   const addHeight = bodyHeight - bodyChild.offsetHeight;
          //   bodyChild.style.height = bodyHeight + 'px';
          //   const tableWrapper = table.getElementsByClassName('ivu-table-wrapper')[0];
          //   tableWrapper.style.height = tableWrapper.offsetHeight + addHeight + 'px';
          //   tableHeight = table.offsetHeight + addHeight + 'px';
          //   console.log(table)
          // }
          if (tableHeight > 500 && !this.options.fitToPage) {
            let wrapperHeight = wrapper.offsetHeight;
            const scale = Math.round(wrapperHeight / (wrapperHeight + tableHeight - 500) * 100)
            docBody.style.zoom = `${scale < 60 ? 60 : scale}%`;
          }
          table.style.height = `${tableHeight}px`;
          table.style.marginBottom = '15px';
        }
      }
    }
    doc.close();

    var removes = document.querySelectorAll('.isNeedRemove');
    for (var k = 0; k < removes.length; k++) {
      removes[k].parentNode.removeChild(removes[k]);
    }

    var _this = this;
    iframe.onload = function(){
      if (_this.options.fitToPage) {
        _this.fitToPage(doc);
      }
      _this.toPrint(w);
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 100)
    }
  },

  fitToPage: function (doc) {
    const body = doc.getElementsByTagName('body')[0];
    const wrapper = doc.getElementsByClassName('print-iframe-wrapper')[0];
    if (!body || !wrapper) return;

    const pageWidth = 190 * 96 / 25.4;
    const pageHeight = 277 * 96 / 25.4;
    const contentWidth = Math.max(wrapper.scrollWidth, wrapper.offsetWidth);
    const contentHeight = Math.max(wrapper.scrollHeight, wrapper.offsetHeight);
    if (!contentWidth || !contentHeight) return;

    const scale = Math.min(1, pageWidth / contentWidth, pageHeight / contentHeight);
    body.style.zoom = `${scale}`;
  },

  toPrint: function (frameWindow) {
    try {
      setTimeout(function () {
        frameWindow.focus();
        try {
          if (!frameWindow.document.execCommand('print', false, null)) {
            frameWindow.print();
          }
        } catch (e) {
          frameWindow.print();
        }
        frameWindow.close();
      }, 10);
    } catch (err) {
    }
  },
  isDOM: (typeof HTMLElement === 'object') ?
    function (obj) {
      return obj instanceof HTMLElement;
    } :
    function (obj) {
      return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
    }
};
const MyPlugin = {}
MyPlugin.install = function (Vue, options) {
  // 4. 添加实例方法
  Vue.prototype.$print = Print
}
export default MyPlugin
